import { PromptTemplateCategory } from '../types';

export const professional: PromptTemplateCategory = {
  title: "Profesional",
  icon: "💼",
  templates: [
    {
      title: "Guión para YouTube / Video",
      content: `Escribe un guión para un video de YouTube narrado por una sola persona.
- El tema del video es [5 errores comunes al trabajar desde casa — y cómo corregirlos].
- Público objetivo: [jóvenes profesionales que comienzan su primer trabajo remoto].
- Tono: [amigable, conversacional y práctico — como consejos de un colega de confianza].
- Estructura con un gancho fuerte en las primeras dos oraciones, transiciones claras entre puntos y un cierre breve con llamada a la acción.
- Escribe para ser hablado: usa contracciones, párrafos cortos y preguntas retóricas para mantener la atención del oyente.`
    },
    {
      title: "Explicación de Producto",
      content: `Escribe un guión de voz en off para un video explicativo de producto.
- El producto es [una aplicación móvil que ayuda a pequeños empresarios a rastrear gastos escaneando recibos].
- Público objetivo: [freelancers y pequeños empresarios que odian la contabilidad].
- Beneficios clave a destacar:
  1. [Escanea un recibo en 2 segundos — sin ingreso manual].
  2. [Categorías de gastos automáticas con sugerencias inteligentes].
  3. [Exportación con un toque para la temporada de impuestos].
- Tono: [claro, animado y tranquilizador — esto hace fácil una tarea dolorosa].
- Mantén las oraciones concisas y directas. Evita la jerga.`
    },
    {
      title: "Discurso de Presentación",
      content: `Escribe un discurso para una presentación profesional o conferencia.
- La ocasión es [una reunión general de la empresa para iniciar un nuevo trimestre].
- El orador es [un líder de equipo dirigiéndose a una audiencia mixta de ingenieros, diseñadores y gerentes].
- Mensaje central: [celebrar los logros del trimestre pasado, reconocer los desafíos con honestidad y unir al equipo en torno a un enfoque claro para los próximos meses].
- Tono: [seguro, genuino y motivador — nada de lenguaje corporativo vacío].
- Duración hablada aproximada: [4 minutos].
- Usa frases conversacionales, pausas estratégicas y una frase final memorable.`
    }
  ]
};
